import { useEffect, useState } from "react";
import Section from "../../parts/Section";
import DiscreetMessage from "../../parts/DiscreetMessage";
import Api from "../../Api";
import moment from "moment";
import { Client } from "../../types";

const ClientsDelete = () => {
  const [clients, setClients] = useState<Client[] | null>(null);

  useEffect(() => {
    Api.clientsGetDeletable().then(setClients);
  }, []);

  if (!clients) return <DiscreetMessage text="Carregando ..." />;

  return (
    <Section className="p-4 flex flex-col gap-4">
      <div className="p-4 rounded-lg bg-sky-100 text-sky-800 font-semibold text-center">
        Clientes sem contratos ou orçamentos
      </div>
      {clients.map((client: Client) => (
        <ClientCard key={client.uuid} client={client} />
      ))}
    </Section>
  );
};

export default ClientsDelete;

const ClientCard = ({ client }: { client: Client }) => {
  const [deleted, setDeleted] = useState(false);

  const remove = () => {
    if (window.confirm("Deletar cliente?")) {
      Api.clientsDelete(client.uuid).then(() => setDeleted(true));
    }
  };

  if (deleted)
    return (
      <div className="p-4 bg-green-50 text-green-700 font-semibold">
        Cliente deletado
      </div>
    );

  return (
    <div className="border rounded-lg shadow-sm">
      <div className="rounded-lg p-4  flex flex-col gap-2">
        <div className="overflow-scroll whitespace-nowrap no-scrollbar font-semibold">
          {client.name}
        </div>

        <div className="text-sm text-gray-600">
          Criado em{" "}
          <span className="font-bold">
            {moment(client.since).format("DD/MM/YYYY HH:mm")}
          </span>
        </div>
      </div>

      <div className="p-4 border-t text-sm flex flex-col gap-4">
        <div>
          <div className="font-semibold">
            {client.type === "pj" ? "CNPJ" : "CPF"}
          </div>
          <div>{client.document}</div>
        </div>

        <div>
          <div className="font-semibold">Endereço</div>
          <div>
            {client.street}, {client.number}, {client.area}
          </div>
          <div>
            {client.city}, {client.state} - {client.zipcode}
          </div>
          {client.complement && (
            <div className="text-gray-500">{client.complement}</div>
          )}
        </div>

        <div>
          <div className="font-semibold">Contato</div>
          {client.contactName && (
            <div className="truncate">{client.contactName}</div>
          )}
          {client.email && <div>{client.email}</div>}
          {client.mobile && <div>{client.mobile}</div>}
          {client.phone && <div>{client.phone}</div>}
        </div>
      </div>

      <button
        className="border-t w-full text-sm rounded-b-lg p-3 font-bold text-red-700 hover:bg-red-50"
        onClick={remove}
      >
        Deletar
      </button>
    </div>
  );
};
